import { render } from "./FormRange.vue?vue&type=template&id=bf71a166"
import script from "./FormRange.vue?vue&type=script&lang=js"
export * from "./FormRange.vue?vue&type=script&lang=js"

import "./FormRange.vue?vue&type=style&index=0&id=bf71a166&lang=scss"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__